import { Component, OnDestroy, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { Observable } from "rxjs";
import { NgbDateStruct, NgbTimeStruct, NgbDateParserFormatter, NgbDate, NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { Store, select } from "@ngrx/store";
import { Router } from "@angular/router";
import { take } from "rxjs/operators";
import { CopyHelpers } from "ClientApp/src/app/shared/helpers/copy.helpers";
import { LeadTimeService } from "ClientApp/src/app/shared/services/leadtime.service";
import { clientConfig } from "../../../shared/constant/app.constant";
import { NavButton } from "../../../shared/components/navigation/next-button.component";
import { passtimeRange } from "../../../shared/helpers/array.helper";
import { AppFlowService } from "../../../shared/services/app-flow/app-flow.service";
import { DeliveryOptionsService, ShippingType } from "../../../shared/services/delivery-options.service";
import {
  addfreeTextToReturnOrder,
  addItemToReturnOrderAction,
  updateDeliveryOptionInReturnOrder,
} from "../../../store/actions/order.actions";
import { LanguageChangeService } from "../../../shared/services/language-change.service";
import { CustomDateParserFormatter } from "../../../shared/services/ngb-date-formatter/custom-date-parser-formatter";
import { TranslationDataService } from "ClientApp/src/app/shared/services/translation-data.service";
import { TranslateService } from "@ngx-translate/core";
import { MapMarker, MapInfoWindow } from "@angular/google-maps";

@Component({
  selector: "app-return-options",
  templateUrl: "./return-options.component.html",
  styleUrls: ["./return-options.component.scss"],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
})
export class ReturnOptionsComponent implements OnDestroy {
  @ViewChildren(MapInfoWindow) infoWindows!: QueryList<MapInfoWindow>;
  latitude: number;
  longitude: number;
  zoom = 12;
  markers: marker[];
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL,
  };
  nextButton: NavButton = {
    buttonText: "Continue",
    cssClass: "next-btn",
  };
  cancelButton: NavButton = {
    buttonText: "Cancel",
    cssClass: "next-btn",
  };
  screenNav: NavButton = {
    buttonText: "Select delivery options",
    cssClass: "back-btn",
    number: 2,
  };
  shippingOption = CopyHelpers.deepCopy(clientConfig.SHIPPING_OPTIONS);
  param = {
    streetaddress: "",
    zipcode: "",
    city: "",
    country: "",
    additionalAddressInformation: "",
    state: "",
    merchantTitle: "",
    pickUpTimeStart: "",
    pickUpTimeEnd: "",
  };
  pickupTimeStart = 0;
  pickupTimeEnd = 0;
  showDialog = false;
  dialogTitle = "Change Address";
  address = "";
  city = "";
  country = "";
  zipcode = "";
  test: any;
  activeCollectionPoints = false;

  model: NgbDateStruct;
  minDate: NgbDateStruct;
  date: { year: number; month: number };
  selectedDate: any = "";
  freeText: string = "";
  merchantName = clientConfig.TENANTNAME.toLowerCase().trim();
  dateDisabled: NgbDate;
  calendar: NgbCalendar;

  time: NgbTimeStruct = { hour: 13, minute: 30, second: 0 };

  returnOrder$: Observable<any>;
  selectedTime: string;
  receiverAddress: any;
  deliveryOptionType: string;
  selectedCarrier: string;
  collectionPoints: any;
  selectedCollectionPoint: any;
  orderAddress: any;
  cancelUri: string;
  dropOfOption = false;
  WeekendPickupAllowed: boolean = false;
  showBackBtn = true;
  techSupport: any;
  showError: any = {
    show: false,
  };

  errorinfo = {
    title: "returnNotCreatedSubject",
    message: "noShippingOptionAvailableBody",
  };

  availableShippingOptions: string[];
  orderData: any;
  isDisabled;
  exceptionDays = [];
  formattedExceptionDays = [];
  enabledDates: NgbDateStruct[] = [];
  disabledTomorrowDateString = "";
  returnOrderData: any;
  subscription: any;

  constructor(
    private router: Router,
    private appFlowService: AppFlowService,
    private store: Store<AppState>,
    private deliveryOptionsService: DeliveryOptionsService,
    public translateService: TranslateService,
    private languageChanged: LanguageChangeService,
    private leadTimeService: LeadTimeService,
    public translationDataService: TranslationDataService
  ) {
    this.languageChanged.languageChanged$.subscribe(() => {
      this.refreshDateSelector();
    });
    if (clientConfig.APPFLOW === "formPostPrePopulatedOrder" || clientConfig.APPFLOW === "loginAppFlowPrePopulated") {
      this.appFlowService.activeStepId = this.appFlowService.getActiveId("shippingoption");
    } else if (
      this.appFlowService.getActiveAppFlow().steps.includes("techSupport") &&
      clientConfig.APPFLOW === "formPostOrderB2CTechSupportFlow"
    ) {
      this.appFlowService.activeStepId = this.screenNav.number + 1;
    } else {
      this.appFlowService.activeStepId = this.screenNav.number;
    }

    this.store.pipe(select("orderData")).subscribe((order) => {
      this.orderData = CopyHelpers.deepCopy(order);
    });

    this.cancelUri = clientConfig.CANCEL_URI;
    this.minDate = this.generateMinDate(7);

    const route = this.appFlowService.findRouteFromSequence("shippingoption");
    let returnOrder: any;
    this.nextButton.routeUrl = `/d/${route.next}`;
    this.screenNav.routeUrl = route.back ? `/d/${route.back}` : "";
    this.returnOrder$ = this.store.pipe(select("returnOrder"));
    this.subscription = this.returnOrder$.subscribe((ro) => {
      returnOrder = ro;
      this.orderAddress = ro.orderAddress;
      if (ro.deliveryOption) {
        if (ro.deliveryOption.time) {
          this.selectedTime = ro.deliveryOption.time;
        }
        if (ro.deliveryOption.date) {
          this.selectedDate = ro.deliveryOption.date;
        }
        if (ro.deliveryOption.type) {
          this.deliveryOptionType = ro.deliveryOption.type;
        } else if (ro.modeOfTransport) {
          if (!ro.modeOfTransport.includes(";")) {
            this.deliveryOptionType = ro.modeOfTransport;
          }
        }
        let isAllFieldValid = true;
        if (deliveryOptionsService.getTypeByMode(ro.deliveryOption.type) === ShippingType.Collection) {
          if (!ro.deliveryOption.date || !ro.deliveryOption.time) isAllFieldValid = false;
        }
        this.nextButton.isDisable = !isAllFieldValid;
      } else {
        this.selectedDate = this.minDate;
        this.selectDate(this.selectedDate);

        this.nextButton.isDisable = true;
      }

      if (
        ro.orderAddress.isoCountry === "" ||
        ro.orderAddress.city === "" ||
        ro.orderAddress.streetAddress === "" ||
        ro.orderAddress.name === ""
      ) {
        console.log("orderAddress", ro.orderAddress);
        this.router.navigate(["/d/updateaddress"]);
      }
      if (
        ro.orderAddress.isoCountry === undefined ||
        ro.orderAddress.city === undefined ||
        ro.orderAddress.streetAddress === undefined ||
        ro.orderAddress.name === undefined
      ) {
        console.log("orderAddress", ro.orderAddress);
        this.router.navigate(["/d/updateaddress"]);
      }
      this.param = {
        streetaddress: this.emptyString(ro.orderAddress.streetAddress),
        city: this.emptyString(ro.orderAddress.city),
        country: ro.orderAddress.isoCountry,
        zipcode: this.emptyString(ro.orderAddress.zipcode),
        additionalAddressInformation: this.emptyString(ro.orderAddress.additionalAddressInformation),
        state: this.emptyString(ro.orderAddress.state),
        merchantTitle: clientConfig.TITLE,
        pickUpTimeStart: "",
        pickUpTimeEnd: "",
      };

      if (clientConfig.SHIPPING_OPTIONS.collection && clientConfig.SHIPPING_OPTIONS.collection.length > 0) {
        this.param.pickUpTimeStart = clientConfig.SHIPPING_OPTIONS.collection[0].pickupTimeStart.substring(0, 5);
        this.param.pickUpTimeEnd = clientConfig.SHIPPING_OPTIONS.collection[0].pickupTimeEnd.substring(0, 5);
      }

      this.loadAvailableShippingOptions(ro.modeOfTransport);
      if (ro.freeText != undefined) {
        this.freeText = ro.freeText;
      }
      this.filterShippingOptionsBasedOnCountry();
    });
    if (!!this.deliveryOptionType) {
      this.selectDeliveryOption(deliveryOptionsService.getShippingOption(this.deliveryOptionType));
    }

    if (clientConfig.APPFLOW === "automaticLoginAppFlow") {
      returnOrder.orderLines.forEach((orderLine) => {
        if (
          (returnOrder.items.findIndex((x) => x.itemNumber === orderLine.itemNumber) === -1 ||
            returnOrder.items.findIndex((x) => x.itemName === orderLine.itemName) === -1) &&
          orderLine.returnable
        ) {
          const newItem = CopyHelpers.deepCopy(orderLine);
          newItem.returnQuantity = newItem.quantityToReturn;
          this.store.dispatch(addItemToReturnOrderAction({ payload: { item: newItem } }));
        }
      });
    }

    if (clientConfig.APPFLOW.includes("TechSupportFlow")) {
      this.store.pipe(select("techSupport")).subscribe((items) => {
        this.techSupport = CopyHelpers.deepCopy(items);
      });

      if (this.techSupport && this.techSupport.items && this.techSupport.items.length === 0) {
        this.showBackBtn = false;
      }
    }

    if (clientConfig.APPFLOW === "loginAppFlowPrePopulated") {
      this.store.pipe(select("returnOrder")).subscribe((items) => {
        this.returnOrderData = CopyHelpers.deepCopy(items);
      });
      this.returnOrderData.orderLines.forEach((orderLine) => {
        if (
          (this.returnOrderData.items.findIndex((x) => x.itemNumber === orderLine.itemNumber) === -1 ||
            this.returnOrderData.items.findIndex((x) => x.itemName === orderLine.itemName) === -1) &&
          orderLine.returnable
        ) {
          const newItem = CopyHelpers.deepCopy(orderLine);
          newItem.returnQuantity = newItem.returnableQuantity;
          this.store.dispatch(addItemToReturnOrderAction({ payload: { item: newItem } }));
        }
      });
    }

    this.getExceptionDates();

    if (this.merchantName === "pandora" || this.merchantName === "tendam" || this.merchantName === "dhl") {
      this.disableCalendarDays();
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  filterShippingOptionsBasedOnCountry() {
    this.shippingOption = CopyHelpers.deepCopy(clientConfig.SHIPPING_OPTIONS);
    var orderCountry = this.orderAddress.isoCountry;

    if (this.shippingOption) {
      if (this.shippingOption.dropOffStore) {
        // Filter dropOffStore based on order country if present
        this.shippingOption.dropOffStore = this.shippingOption.dropOffStore.filter((store) => {
          return (
            !store.allowedCountries ||
            store.allowedCountries.length === 0 ||
            store.allowedCountries.includes(orderCountry)
          );
        });
      }

      if (this.shippingOption.dropOffServiceCenter) {
        // Filter dropOffServiceCenter based on order country if present
        this.shippingOption.dropOffServiceCenter = this.shippingOption.dropOffServiceCenter.filter((store) => {
          return (
            !store.allowedCountries ||
            store.allowedCountries.length === 0 ||
            store.allowedCountries.includes(orderCountry)
          );
        });
      }

      if (this.shippingOption.collection) {
        // Filter collection based on order country if present
        this.shippingOption.collection = this.shippingOption.collection.filter((store) => {
          return (
            !store.allowedCountries ||
            store.allowedCountries.length === 0 ||
            store.allowedCountries.includes(orderCountry)
          );
        });
      }
    }
  }

  getExceptionDates() {
    if (this.merchantName === "pandora") {
      let request = {};
      if (this.orderData && clientConfig.Lead_Time_Config) {
        request = {
          network: {
            provider: clientConfig.Lead_Time_Config.carrier,
            service: clientConfig.Lead_Time_Config.carrierService,
          },
          includeLeadTimeConfiguration: true,
          node: {
            code: this.orderData.orders[0].returnToAddress.isoCountry,
            isAlternativeCode: false,
            alternativeCodeCountry: this.orderData.orders[0].returnToAddress.isoCountry,
          },
          includeAlternativeNodeCodes: true,
        };

        this.leadTimeService.getExceptionDates(request).subscribe((response: any) => {
          this.exceptionDays.push(...response.exceptionDays);
        });
      }
    }
  }

  generateMinDate(offset) {
    const current = new Date();
    const nextweek = new Date(current.getFullYear(), current.getMonth(), current.getDate() + offset);
    return {
      year: nextweek.getFullYear(),
      month: nextweek.getMonth() + 1,
      day: nextweek.getDate(),
    };
  }

  generateHours(collection) {
    const start = this.parsePickup(collection, 1);
    const end = this.parsePickup(collection, 2);

    return passtimeRange(start, end);
  }

  hasStoreNetwork(dropOff) {
    try {
      return dropOff.storeNetwork.length > 0;
    } catch (exception) {}
    return false;
  }

  hasCollectionNetwork(collection) {
    try {
      return collection.collectionNetwork.length > 0;
    } catch (exception) {}
    return false;
  }

  haveShippingOptions() {
    try {
      return this.availableShippingOptions.length > 0;
    } catch (exception) {}
    return false;
  }

  hasCancelUri() {
    try {
      return this.cancelUri !== "" && this.cancelUri !== undefined;
    } catch (exception) {}
    return false;
  }

  isShippingOptionAvailable(option) {
    if (
      clientConfig.APPFLOW !== "formPostPrePopulatedOrder" &&
      clientConfig.APPFLOW !== "formPostPrePopulatedOrderTechSupportFlow"
    )
      return true;

    try {
      return this.availableShippingOptions.includes(option);
    } catch (Exception) {}
    return false;
  }

  exist(val1) {
    return val1 !== undefined && val1 !== null;
  }

  loadAvailableShippingOptions(filter) {
    this.availableShippingOptions = this.deliveryOptionsService.getAvailableModeOfTransport();

    if (
      clientConfig.APPFLOW !== "formPostPrePopulatedOrder" &&
      clientConfig.APPFLOW !== "formPostPrePopulatedOrderTechSupportFlow"
    )
      return;

    if (!this.exist(filter)) return;
    if (filter === "") return;

    const requestModeOfTransport = filter.split(";");

    this.availableShippingOptions = this.availableShippingOptions.filter((s) => requestModeOfTransport.includes(s));
  }

  showDateSelector = true;
  refreshDateSelector() {
    this.showDateSelector = false;
    setTimeout(() => {
      this.showDateSelector = true;
    }, 10);
  }

  parsePickup(shippingOptionParam: any, mode: any) {
    if (mode === 0) {
      try {
        return shippingOptionParam.pickupTimeStart;
      } catch (Exception) {
        return "0";
      }
    }
    if (mode === 1) {
      try {
        return parseInt(shippingOptionParam.pickupTimeStart.split(":")[0], 10);
      } catch (Exception) {
        return 0;
      }
    }
    if (mode === 2) {
      try {
        return parseInt(shippingOptionParam.pickupTimeEnd.split(":")[0], 10);
      } catch (Exception) {
        return 0;
      }
    }
    if (mode === 3) {
      try {
        return shippingOptionParam.firstPickupDayOffsetInDays;
      } catch (Exception) {
        return 0;
      }
    }
  }

  convertToDate(time: string) {
    return new Date("2000-01-30T" + time);
  }

  emptyString(value) {
    if (value === null || value === "" || value === undefined) {
      return (value = "");
    }
    return value + ",";
  }

  changeAddress() {
    this.router.navigate(["/d/updateaddress"]);
  }

  validate(orderData) {
    let isvalidate = true;
    if (orderData && orderData.deliveryOption && orderData.deliveryOption.type) {
      if (this.deliveryOptionsService.getTypeByMode(orderData.deliveryOption.type) === ShippingType.Collection) {
        if (orderData.deliveryOption.date && orderData.deliveryOption.time) {
          isvalidate = true;
        } else {
          isvalidate = false;
          this.showError = {
            show: true,
            message: "missingDateTime",
          };
        }
      }
    } else {
      isvalidate = false;
      this.showError = {
        show: true,
        message: "missingSelection",
      };
    }
    return isvalidate;
  }

  navigate() {
    if (!this.haveShippingOptions()) return;
    if (this.merchantName === "tendam") {
      this.addFreeText();
    }
    const route = this.appFlowService.findRouteFromSequence("shippingoption");
    let order: any;
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        order = ro;
      });
    if (this.validate(order)) {
      this.router.navigate([`/d/${route.next}`]);
    }
  }

  selectDeliveryOption(shippingOption: any) {
    if (shippingOption === null || shippingOption === undefined) return;

    this.selectedCarrier = shippingOption.collectionPointCarrier;

    if (!!shippingOption.collectionPointNetwork) {
      this.activeCollectionPoints = false;
      this.collectionPoints = this.deliveryOptionsService
        .getCollectionPoints(this.orderAddress, shippingOption.collectionPointNetwork)
        .subscribe((res) => {
          this.collectionPoints = res;
          this.setMarkers(res);
        });
    }

    this.dropOfOption = false;
    this.store.dispatch(
      updateDeliveryOptionInReturnOrder({
        payload: {
          type: this.deliveryOptionType,
          deliveryOptionCarrier: this.selectedCarrier,
          isDangerousGoods: shippingOption.isDangerousGoods ? shippingOption.isDangerousGoods : false,
          carrier: shippingOption.carrier ? shippingOption.carrier : null,
          carrierService: shippingOption.carrierService ? shippingOption.carrierService : null,
          labelFormat: shippingOption?.labelFormat ?? null,
        },
      })
    );

    if (this.deliveryOptionsService.getTypeByMode(shippingOption.modeOfTransport) === ShippingType.Collection) {
      const mot = shippingOption.modeOfTransport;
      const collectionConfig = clientConfig.SHIPPING_OPTIONS?.collection?.find(
        (c) => c.modeOfTransport?.toLowerCase() === mot?.toLowerCase()
      );

      this.WeekendPickupAllowed = collectionConfig?.weekendPickupAllowed === true;

      this.disableCalendarDays(this.WeekendPickupAllowed);

      if (!shippingOption.preferredPickup || shippingOption.preferredPickupWithOffsetDays) {
        this.selectedTime = shippingOption.pickupTimeStart;

        this.selectTime(this.selectedTime);

        this.minDate = this.selectedDate = !!shippingOption.firstPickupDayOffsetInDays
          ? this.generateMinDate(shippingOption.firstPickupDayOffsetInDays)
          : this.generateMinDate(7);

        if (this.merchantName === "pandora") {
          this.disableDatesAndSetSelectedDate();
          this.enableComing5Days();
        } else if (this.merchantName === "tendam") {
          this.disableWeekendsRecursively();
        }

        this.selectDate(this.selectedDate);
      }

      if (shippingOption.preferredPickupTimeDisabled) {
        this.selectedTime = shippingOption.pickupTimeStart;
        this.selectTime(this.selectedTime);
      }
    }
  }

  disableCalendarDays(WeekendPickupAllowed: boolean = false) {
    if (this.merchantName === "pandora" || this.merchantName === "tendam" || this.merchantName === "dhl") {
      const self = this;
      // step 2. This gets called when we open calendar
      this.isDisabled = (date: NgbDate) => {
        const d = new Date(date.year, date.month - 1, date.day);

        let result = false;

        if (this.merchantName === "pandora") {
          result = self.disableComingDate(d);
          if (result) return result;

          result = self.disableExceptionDates(d);
          if (result) return result;
        }

        if (!WeekendPickupAllowed) {
          result = self.disableWeekends(d);
          if (result) return result;
        }

        // This line should be executed at the last, that's why separate if statement for this execution
        if (this.merchantName === "pandora") {
          return this.enabledDates.find((x) => new NgbDate(x.year, x.month, x.day).equals(date)) ? false : true;
        }
      };
    }
  }

  // step 1. This gets called when we select collection, and is used to set selected date on the input correctly
  disableDatesAndSetSelectedDate() {
    this.disableComingDate(this.getSelectedDate());
    this.disableExceptionDates(this.getSelectedDate());
    this.disableWeekendsRecursively();
  }

  getSelectedDate() {
    return new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
  }

  disableWeekendsRecursively() {
    if (this.getSelectedDate().getDay() === 6 || this.getSelectedDate().getDay() === 0) {
      this.disableWeekends(this.getSelectedDate());
      this.disableWeekendsRecursively();
    } else {
      return;
    }
  }

  enableComing5Days() {
    // Get today's date
    const today = new Date();

    // Number of days to enable after today
    let daysToEnable = 5;

    // Array to store enabled dates
    this.enabledDates = [];

    // Loop through each day after today, up to the number of days to enable
    for (let i = 1; i <= daysToEnable; i++) {
      // Calculate the next day
      const nextDay = new Date(today.getTime() + i * 24 * 60 * 60 * 1000);

      // we need to enable coming 5 days after selected date
      if (this.getSelectedDate().getTime() > nextDay.getTime()) {
        daysToEnable++;
        continue;
      }

      // Check if the day is tomorrow and current day's time elapsed 16:00
      if (this.disabledTomorrowDateString && this.disabledTomorrowDateString === nextDay.toDateString()) {
        if (this.enabledDates && this.enabledDates.length < 5) daysToEnable++;
        continue;
      }
      // Check if the day is a weekend day (Saturday or Sunday)
      else if (nextDay.getDay() === 0 || nextDay.getDay() === 6) {
        // If it is a weekend day, skip it and continue to the next day
        if (this.enabledDates && this.enabledDates.length < 5) daysToEnable++;
        continue;
      }
      // Check if the day is exception day (carrier unavailable)
      else if (
        this.exceptionDays.findIndex(
          (x) => new Date(x.year, x.month - 1, x.day).toDateString() === nextDay.toDateString()
        ) !== -1
      ) {
        if (this.enabledDates && this.enabledDates.length < 5) daysToEnable++;
        continue;
      }

      // If the next day is not a disabled day, add it to the array of enabled dates
      this.enabledDates.push({ year: nextDay.getFullYear(), month: nextDay.getMonth() + 1, day: nextDay.getDate() });

      // set selected date
      if (this.enabledDates && this.enabledDates.length > 0) {
        this.selectedDate = {
          year: this.enabledDates[0].year,
          month: this.enabledDates[0].month,
          day: this.enabledDates[0].day,
        };
      }
    }
  }

  disableComingDate(currentDate: Date) {
    const tomorrow = new Date();
    let tomorrowUtc = new Date(
      tomorrow.getUTCFullYear(),
      tomorrow.getUTCMonth(),
      tomorrow.getUTCDate(),
      tomorrow.getUTCHours(),
      tomorrow.getUTCMinutes(),
      tomorrow.getUTCSeconds()
    );
    tomorrowUtc = new Date(tomorrowUtc.setDate(tomorrowUtc.getDate() + 1));

    // check for weekend, and increment the day to be disabled if 16:00 of today passed
    tomorrowUtc = this.checkIfWeekendIncrementTheDay(tomorrowUtc);
    // check for exception day, and increment the day to be disabled if 16:00 of today passed
    tomorrowUtc = this.checkIfExceptionDayIncrementTheDay(tomorrowUtc);

    const now = new Date();
    const nowUtc = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const today4pmUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 16, 0, 0);

    if (nowUtc.getTime() > today4pmUtc.getTime() && currentDate.toDateString() === tomorrowUtc.toDateString()) {
      if (
        this.selectedDate &&
        tomorrowUtc.getDate() === this.selectedDate.day &&
        tomorrowUtc.getMonth() + 1 === this.selectedDate.month &&
        tomorrowUtc.getFullYear() === this.selectedDate.year
      ) {
        this.selectedDate = {
          year: this.selectedDate.year,
          month: this.selectedDate.month,
          day: this.selectedDate.day + 1,
        };
      }

      this.disabledTomorrowDateString = tomorrowUtc.toDateString();
      return true;
    }
  }

  disableExceptionDates(currentDate: Date) {
    if (this.exceptionDays && this.exceptionDays.length !== 0) {
      for (let exceptionDay of this.exceptionDays) {
        const exceptionDate = new Date(exceptionDay.year, exceptionDay.month - 1, exceptionDay.day);
        if (exceptionDate.getTime() === currentDate.getTime()) {
          if (
            this.selectedDate &&
            exceptionDate.getDate() === this.selectedDate.day &&
            exceptionDate.getMonth() + 1 === this.selectedDate.month &&
            exceptionDate.getFullYear() === this.selectedDate.year
          ) {
            this.selectedDate = {
              year: this.selectedDate.year,
              month: this.selectedDate.month,
              day: this.selectedDate.day + 1,
            };
          }
          return true;
        }
      }
    }
    return false;
  }

  disableWeekends(currentDate: Date) {
    if (currentDate.getDay() === 6 || currentDate.getDay() === 0) {
      if (
        this.selectedDate &&
        currentDate.getDate() === this.selectedDate.day &&
        currentDate.getMonth() + 1 === this.selectedDate.month &&
        currentDate.getFullYear() === this.selectedDate.year
      ) {
       const nextDay = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day + 1);
        this.selectedDate = {
          year: nextDay.getFullYear(),
          month: nextDay.getMonth() + 1,
          day: nextDay.getDate(),
        };
      }

      return true;
    }
    return false;
  }

  isExceptionDay(day: Date) {
    if (
      day &&
      this.exceptionDays.findIndex(
        (x) => new Date(x.year, x.month - 1, x.day).toDateString() === day.toDateString()
      ) !== -1
    ) {
      return true;
    }

    return false;
  }

  isWeekend(day: Date) {
    if (day && (day.getDay() === 6 || day.getDay() === 0)) {
      return true;
    }

    return false;
  }

  checkIfWeekendIncrementTheDay(day: Date) {
    if (this.isWeekend(day)) {
      day = new Date(day.setDate(day.getDate() + 1));

      this.checkIfWeekendIncrementTheDay(day);
    } else {
      return day;
    }
  }

  checkIfExceptionDayIncrementTheDay(day: Date) {
    if (this.isExceptionDay(day)) {
      day = new Date(day.setDate(day.getDate() + 1));

      this.checkIfExceptionDayIncrementTheDay(day);
    } else {
      return day;
    }
  }

  setMarkers(collectionPoints: any) {
    if (collectionPoints === undefined || collectionPoints.collectionPoints === undefined) return;

    this.activeCollectionPoints = true;
    this.markers = [];

    if (this.orderAddress.latitude && this.orderAddress.longitude) {
      this.latitude = this.orderAddress.latitude;
      this.longitude = this.orderAddress.longitude;
    }
    let identifier = 1;

    collectionPoints.collectionPoints.forEach((point) => {
      const openingHours = point.openingHours[new Date().getDay() - 1];
      let opens = undefined;
      let closes = undefined;

      if (openingHours !== undefined && openingHours !== null) {
        opens = openingHours.hours[0].opens;
        closes = openingHours.hours[0].closes;
      }
      if (this.latitude === undefined && this.longitude === undefined) {
        this.latitude = collectionPoints.collectionPoints[0].geoPoint.latitude;
        this.longitude = collectionPoints.collectionPoints[0].geoPoint.longitude;
      }
      this.markers.push({
        label: identifier.toString(),
        latitude: point.geoPoint.latitude,
        longitude: point.geoPoint.longitude,
        name: point.name,
        street: point.street,
        houseNumber: point.houseNumber,
        zipCode: point.zipCode,
        city: point.city,
        distance: point.distance,
        distanceUnit: point.distanceUnit,
        opens: opens,
        closes: closes,
      });
      identifier++;
      this.setTodaysOpeningHour(point);
    });
  }

  selectDate(ngbDate: NgbDateStruct) {
    this.store.dispatch(
      updateDeliveryOptionInReturnOrder({
        payload: {
          date: ngbDate,
        },
      })
    );
  }
  selectTime(time: any) {
    this.store.dispatch(
      updateDeliveryOptionInReturnOrder({
        payload: {
          time: time,
        },
      })
    );
  }

  addFreeText() {
    this.store.dispatch(
      addfreeTextToReturnOrder({
        payload: {
          freeText: this.freeText,
        },
      })
    );
  }

  //modal
  openDialgBox() {
    this.showDialog = !this.showDialog;
    this.address = "";
    this.city = "";
    this.country = "";
    this.zipcode = "";
  }

  onVisibleChange(event: boolean): void {
    console.log("called", event);
    if (!event) {
      this.showDialog = false;
    }
  }

  save() {
    console.log("location", this.address, this.city, this.country, this.zipcode);
    this.showDialog = false;
  }

  cancel() {
    this.showDialog = false;
  }

  onItemChange(event) {
    this.selectedDate = "";
    this.test = event.target.value;
    console.log(this.test, "selected target");
  }

  select(date) {
    console.log(date);
    this.selectedDate = date;
  }
  showDetails(index) {
    if (this.selectedCollectionPoint === index) {
      this.selectedCollectionPoint = "";
    } else {
      this.selectedCollectionPoint = index;
    }
  }

  setTodaysOpeningHour(point: any) {
    const today = new Date().getDay() - 1;
    point.openingHours.forEach((openingHour) => {
      if (today === openingHour.day) {
        point.todaysOpeningHour = openingHour.hours;
      }
    });
  }

  onMarkerClick(i: number, markerElem: MapMarker) {
    this.infoWindows.toArray().forEach((infoWindow: MapInfoWindow, index: number) => {
      if (i === index) {
        infoWindow.open(markerElem);
      }
    });
  }
}

interface marker {
  label: string;
  latitude: number;
  longitude: number;
  name: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  distance: number;
  distanceUnit: string;
  opens: string;
  closes: string;
}
